module.exports = "/images/logo-travelbank.svg?356dad26eb8876bb8552c509a1f5159c";